var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"production-expense","route":"/reports/billing-production-expense","file-name":"producao-por-procedimento.xlsx","period-label":"Período do atendimento","columns":_vm.columns,"default-days":30}})
}
var staticRenderFns = []

export { render, staticRenderFns }